import defaultReducer from "./defaultReducer";

export default defaultReducer("FRS_CLIENT_SECRET_KEY_MODAL", {
  open: false,
  key: "",
});
